var TRANS_DICT = {
  "INVITATION_SENT": "Your invitation was successfully sent.",
  "LOADING_USERS": "Loading users..",
  "EMAIL_IS_INVALID": "Your invitation could not be sent because the email provided was invalid.",
  "EMAILS_IS_INVALID": "Your invitation was not sent to one or more users due to invalid email addresses.",
  "EMAIL_ALREADY_EXIST_IN_PROJECT": "Your invitation was not sent because that user is already a project member.",
  "EMAILS_ALREADY_EXIST_IN_PROJECT": "Your invitation was not sent to one or more users because they are already a project member.",
  "SELECT_ALL": "Select all",
  "SELECT_A_GROUP": "Select a group",
  "USER": "User",
  "ADMIN": "Admin",
  "HIDE_GROUPS": "Hide groups",
  "ADD_TO_GROUP": "Add to a group",
  "ADD_PEOPLE": "Add people",
  "ADD_MORE_PEOPLE": "Add more people..",
  "CANCEL": "Cancel",
  "ADD": "Add",
  "INVITE": "Invite",
  "ROLE": "Role",
  "GROUPS": "Groups",
  "ENTER_VALID_EMAIL": "Please enter valid email addresses",
  "INVITE_USER": "Invite user",
  "INVITE_OTHER_TO_PROJECT": "Invite others to #ObjectName#",
  "INVITE_FROM_COMPANY": "Invite from {{CompanyName}}",
  "STILL_LOADING_Z_USERS": "Still loading {{z}} users..",
  "SCROLL_DOWN_FOR_MORE_USERS": "Please scroll down to load more users.",
  "SEARCH_ON_LOADED_USERS": "Search will be perform only on loaded users.",
  "COMPANY_SEARCH_ICON": "Search users from your company",
  "SEARCH_USERS": "Search users",
  "NO_COMPANY": "No Company loaded. Please contact admin.",
  "PEOPLE": "People",
  "LOADED_X_FROM_Y_USERS": "Loaded {{x}} from {{y}} users"
};

export default TRANS_DICT;